import { render, staticRenderFns } from "./BenefactorForm.vue?vue&type=template&id=0ff4ec5b&scoped=true"
import script from "./BenefactorForm.vue?vue&type=script&lang=js"
export * from "./BenefactorForm.vue?vue&type=script&lang=js"
import style0 from "./BenefactorForm.vue?vue&type=style&index=0&id=0ff4ec5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff4ec5b",
  null
  
)

export default component.exports